import { AuthHelper } from "./AuthHelper";

export class ErrorHelper {
    static handle(error: any) {
        console.error(error);
        if (error.response?.status === 401) {
            AuthHelper.signOut();
        }
    }
}